import React from 'react'
import { Card } from 'primereact/card'
import './CustomCardColorBar.css'

export default function CustomCardColorBar({ title, subTitle, value, barColor }) {
  return (
    <Card
      className="CustomCardColorBar"
      title={title}
      subTitle={subTitle}
      style={{ borderTop: `5px solid ${barColor}` }}
    >
      <h1 className="text-center" style={{ margin: 0 }}>
        {value}
      </h1>
    </Card>
  )
}
